import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

import { damageTypePageConfirmedAtom } from './damageTypePageConfirmedAtom';
import { deviceDetailsPageConfirmedAtom } from './deviceDetailsPageConfirmedAtom';

export const deviceTypePageConfirmedAtomWithStorage = atomWithStorage<boolean>(
  'si-tec-car-device-type-page-confirmed',
  false,
  storage<boolean>(),
  {
    getOnInit: true,
  }
);

export const deviceTypePageConfirmedAtom = atom(
  (get) => get(deviceTypePageConfirmedAtomWithStorage),
  (get, set, update: boolean) => {
    set(deviceTypePageConfirmedAtomWithStorage, update);
    set(deviceDetailsPageConfirmedAtom, false);
    set(damageTypePageConfirmedAtom, false);
  }
);
